import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatRippleModule } from '@angular/material/core';
import { KeyValuePipe } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { TranslateModule } from '@ngx-translate/core';
import { TranslateOperationName } from '@data-terminal/ui-presentational/pipes';
import { ConsumptionEntity } from '@data-terminal/shared-models/consumption.model';
import { BatchInformationService } from '@data-terminal/feature-dialogs/services/batch-information/batch-information.service';
import { DynamicDatePipe } from '@data-terminal/utils/pipes/dynamic-date.pipe';

export interface OperationBatchInformation {
    [key: string]: BatchInformation[];
}

export interface BatchInformation {
    deviceId: string;
    operationName: string;
    batchId: string;
    consumption: number;
    materialId: string;
    timestamp: number | undefined;
}

@Component({
    selector: 'data-terminal-single-machine-batch-information',
    imports: [
        MatExpansionModule,
        MatRippleModule,
        KeyValuePipe,
        DynamicDatePipe,
        MatTableModule,
        TranslateOperationName,
        TranslateModule,
    ],
    templateUrl: './single-machine-batch-information.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SingleMachineBatchInformationComponent implements OnInit {
    @Input() machineId!: string;
    @Input() consumptions!: ConsumptionEntity[];

    readonly #batchInformationService = inject(BatchInformationService);
    batchInformation: OperationBatchInformation = {};
    machineName = '';
    operationName = '';

    displayedColumns: string[] = ['material', 'amount', 'batch', 'timestamp'];

    ngOnInit(): void {
        this.batchInformation = this.#batchInformationService.prepareBatchInformation(this.consumptions);
        this.machineName = this.#batchInformationService.findMachineNameById(this.machineId);
        if (this.batchInformation) {
            this.operationName = Object.values(this.batchInformation)[0][0].operationName;
        }
    }
}
